/* eslint react/no-danger: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLabels } from 'wsm-common-data';

const WarrantyModal = ({ warrantyItems, closeModal }) => {
	// TODO: Remove after contact us link is working
	// useEffect(() => {
	// 	// trigger refresh on dialog jQuery module
	// 	$(document).trigger('modulesRefresh', {
	// 		modules: { dialog: window.DDC?.modules?.dialog }
	// 	});
	// });

	const {
		requestData: { deviceType }
	} = useSelector((state) => state);
	const labels = useLabels();

	const modalClass = deviceType === 'DESKTOP' ? 'text-center' : 'text-left';
	const doneBtnClass = deviceType === 'MOBILE' ? 'btn btn-block' : '';

	// TODO: Remove after contact us link is working
	// const regex = /([a-f0-9]){32}/;
	// const match = window.location.href.match(regex);
	// const uuid = match ? match[0] : '';
	// const pageAlias = window.DDC?.siteSettings?.pageAlias || '';
	// const contactUS = labels.get('CONTACT_US');

	const done = labels.get('DONE');

	return (
		<>
			{warrantyItems.map((item) => {
				return (
					<div className={` ${modalClass} mb-4`}>
						<div
							dangerouslySetInnerHTML={{
								__html: item.description
							}}
						/>
						<div
							className="font-weight-bold"
							dangerouslySetInnerHTML={{ __html: item.detail }}
						/>
					</div>
				);
			})}
			{/*
			TODO: Remove comments after fixing bugs
			Bug 1) on desktop it takes few seconds to open contact us form when warranty modal is close
			Bug 2) on Mobile contact us form is not visible or working
			<div className={`${modalClass} mb-4`}>
				Please
				<a
					className="ml-2 mr-2 primary-link dialog"
					href={`#?parentPageAlias=${pageAlias}`}
					rel="nofollow"
					data-width="375"
					data-href={`/contact-form.htm?itemId=${uuid}&vehicleId=${uuid}&category=new&parentPageAlias=${pageAlias}`}
					data-title="Request More Info"
					data-link-label="ASK"
					onClick={closeModal}
				>
					{contactUS}
				</a>
				for full warranty details
			</div>
		*/}
			<button
				className={`${doneBtnClass} btn-primary align-center`}
				onClick={closeModal}
				type="button"
			>
				{done}
			</button>
		</>
	);
};

WarrantyModal.propTypes = {
	warrantyItems: PropTypes.arrayOf(
		PropTypes.shape({
			description: PropTypes.string,
			detail: PropTypes.string
		})
	),
	closeModal: PropTypes.func
};

export default WarrantyModal;
